// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__OPf8N","subheader":"ReorderModal_subheader__21ddN","listWrap":"ReorderModal_listWrap__fR1U-"};